import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, BrowserRouter as Router, Route, Link, useLocation } from "react-router-dom";
import "./componentCss/sidebar.css";
function Sidebar() {
  const closeSidebar = (e) => {
    e.preventDefault();
    document.body.classList.remove("sidebar-close"); // Removes the sidebar-open class
  }
  const navigate = useNavigate();
  const location = useLocation();
  const [pathOpen,setPathOpen] = useState(location.pathname);
  const [isCustomerDetailsOpen, setIsCustomerDetailsOpen] = useState();
  const [isServiceOpen, setIsServiceOpen] = useState();
  const [isAccountDetailsOpen, setIsAccountDetailsOpen] = useState();
  const [isStockDetailsOpen, setIsStockDetailsOpen] = useState();
  const [isReportDetailsOpen, setIsReportDetailsOpen] = useState();
  const toggleCustomerDetails = () => setIsCustomerDetailsOpen(!isCustomerDetailsOpen);
  const toggleServiceDetails = () => setIsServiceOpen(!isServiceOpen);
  const toggleAccountDetails = () => setIsAccountDetailsOpen(!isAccountDetailsOpen);
  const toggleStockDetails = () => setIsStockDetailsOpen(!isStockDetailsOpen);
  const toggleReportDetails = () => setIsReportDetailsOpen(!isReportDetailsOpen);
  const user = getCookie('user');
  const isStaff = getCookie('isStaff') === "true";
  const secretId = getCookie('secretId');
  function getCookie(name) {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
      const [key, value] = cookie.split('=');
      if (key === name) { return value; }
    }
    return null;
  }
  if (!user) {
    navigate('/login');
  }
  useEffect( ()=>{
    
    if(location.pathname.includes("/allCustomer") || location.pathname ==="/unpaidcustomer" || location.pathname ==="/paidcustomer" || location.pathname ==="/creditcustomer" || location.pathname ==="/groupcustomer" || location.pathname ==="/activecustomer" || location.pathname ==="/deactivecustomer" || location.pathname ==="/streetDetails" || location.pathname ==="/addCustomer"){
      setIsCustomerDetailsOpen(true);
      setIsServiceOpen(false);
      setIsAccountDetailsOpen(false);
      setIsStockDetailsOpen(false);
      setIsReportDetailsOpen(false);
      
    }else if(location.pathname === "/stbreplacement" || location.pathname ==="/generalservice" || location.pathname ==="/tripsheet"){
      setIsServiceOpen(true);
      setIsCustomerDetailsOpen(false);
      setIsAccountDetailsOpen(false);
      setIsStockDetailsOpen(false);
      setIsReportDetailsOpen(false);
      
    }else if(location.pathname === "/generalExpense" || location.pathname ==="/tccltopup" || location.pathname ==="/materialpurchase" || location.pathname ==="/electricBill" || location.pathname ==="/employeeSalary" || location.pathname ==="/officeRent" ){
      setIsServiceOpen(false);
      setIsAccountDetailsOpen(true);
      setIsCustomerDetailsOpen(false);
      setIsStockDetailsOpen(false);
      setIsReportDetailsOpen(false);
    }else if(location.pathname === "/unassignedStb" || location.pathname ==="/StPurchase" || location.pathname ==="/stbReturn" || location.pathname ==="/stbType" ){
      setIsStockDetailsOpen(true);
      setIsServiceOpen(false);
      setIsAccountDetailsOpen(false);
      setIsCustomerDetailsOpen(false);
      setIsReportDetailsOpen(false);
    } else if(location.pathname === "/singlecustomerreport" || location.pathname ==="/connectionreport" || location.pathname ==="/customerreport" || location.pathname ==="/networkwisereport" || location.pathname ==="/reversecustomerreport" || location.pathname ==="/collectionstaffreport" || location.pathname ==="/accountsreport" || location.pathname ==="/monthlyreport" ){

      setIsReportDetailsOpen(true)
      setIsCustomerDetailsOpen(false);
      setIsServiceOpen(false);
      setIsAccountDetailsOpen(false);
      setIsStockDetailsOpen(false);
    } else {
      setIsReportDetailsOpen(false)
      setIsCustomerDetailsOpen(false);
      setIsServiceOpen(false);
      setIsAccountDetailsOpen(false);
      setIsStockDetailsOpen(false);

    }
  } , [location.pathname])
  return (
    <aside className="main-sidebar sidebar-dark-light bg-navy elevation-4">
      <div className="brand-link bg-navy">
        <img src="../asset/img/logo.png" className='img-circle brand-image elevation-3' height={"40px"} width={"40px"} alt="" />
        <span className="brand-text h4">Cable Tv Pay</span>
        <div className="d-flex justify-content-end">
          <i className=" fas fa-times py-1 d-lg-none position-fixed top-0 end-0 z-index-5 mx-1 mt-1 text-bold text-light my-2" data-widget="pushmenu" href="#" role="button" style={{ top: "10px" }} />
        </div>
      </div>
      <div className="sidebar">
        <nav className="mt-1">
          <ul className="nav nav-pills nav-sidebar flex-column pt-3" data-widget="treeview" role="menu" data-accordion="false">
            <li className="nav-item">
              <div className="nav-link text-light text-orange" style={{backgroundImage: "linear-gradient(to bottom, white, white, rgb(184, 177, 177))"}}>
                <i className="nav-icon fas fa-user-circle h-100"/>
                <p className="ms-2 font-truncate text-bold">{user}</p>
              </div>
            </li>
          {((isStaff && secretId === "superadmin") || !isStaff) && (
            <li className="nav-item">
              <Link
                className={`nav-link ${pathOpen === '/home' ? 'headActive' : 'none'}`}
                to={`/home`}
              >
                <i className="nav-icon fas fa-home" />
                <p className="ms-2 font-truncate">Dashboard</p>
              </Link>
            </li>
          )}
                      <li className="nav-item">
              <div className={`nav-link ${isCustomerDetailsOpen ? 'bg-light text-dark' : 'text-white'}`} onClick={toggleCustomerDetails} >
                <i className="nav-icon fas fa-user-tie" />
                <p>Customer Details <span style={{ position: "absolute", left: "auto", right: "8px" }}>
                  <i className={`fas ${isCustomerDetailsOpen ? 'fa-chevron-down' : 'fa-chevron-left'}`} />
                </span></p>
              </div>

              <li id="customerDetailsSubmenu">
                <div className={`collapse-menu ${isCustomerDetailsOpen ? 'open ' : ''}`}>
                  <ul className="nav flex-column">
                    <li className={`nav-item`}>
                      <Link to={`/allCustomer/all`} className={`nav-link text-light ${pathOpen.includes('/allCustomer') ? 'headActive' : 'none'}`}>
                        <i className="fas fa-users" style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>All Customer</p>
                      </Link>
                    </li>
                   {!isStaff && (
                    <li className={`nav-item`}>
                      <Link to="/paidcustomer" className={`nav-link text-light ${pathOpen ==='/paidcustomer' ? 'headActive' : 'none'}`}>
                        <i className="fas fa-user-check" style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>Paid Customer</p>
                      </Link>
                    </li>)}
                     {!isStaff && (
                    <li className={`nav-item`}>
                      <Link to="/unpaidcustomer" className={`nav-link text-light ${pathOpen === '/unpaidcustomer' ? 'headActive' : 'none'}`}>
                        <i className="fas fa-user-minus" style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>Unpaid Customer</p>
                      </Link>
                    </li>
                    )}
                     {!isStaff && (
                    <li className={`nav-item`}>
                      <Link to="/creditcustomer" className={`nav-link text-light ${pathOpen === '/creditcustomer' ? 'headActive' : 'none'}`}>
                        <i className="fas fa-crown" style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>Credit Customer</p>
                      </Link>
                    </li>
                    )}
                     {!isStaff && (
                    <li className={`nav-item`}>
                      <Link to="/groupcustomer" className={`nav-link text-light ${pathOpen === '/groupcustomer' ? 'headActive' : 'none'}`}>
                        <i className="fas fa-user-friends" style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>Group Customer</p>
                      </Link>
                    </li>
                    )}
                     {!isStaff && (
                    <li className={`nav-item`}>
                      <Link to="/activecustomer" className={`nav-link text-light ${pathOpen === '/activecustomer' ? 'headActive' : 'none'}`}>
                        <i className="fas fa-user-plus" style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>Active Customer</p>
                      </Link>
                    </li>
                    )}
                     {!isStaff && (
                    <li className={`nav-item`}>
                      <Link to="/deactivecustomer" className={`nav-link text-light ${pathOpen === '/deactivecustomer' ? 'headActive' : 'none'}`}>
                        <i className="fas fa-user-times" style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>Deactive Customer</p>
                      </Link>
                    </li>
                    )}
                     {!isStaff && (
                    <li className={`nav-item`}>
                      <Link to="/streetDetails" className={`nav-link text-light ${pathOpen === '/streetDetails' ? 'headActive' : 'none'}`}>
                        <i className="fas fa-map-marker-alt" style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>Street Details</p>
                      </Link>
                    </li>
                    )}
                    {((isStaff && secretId === "superadmin") || !isStaff) && (
                    <li className={`nav-item`}>
                      <Link to="/addCustomer" className={`nav-link text-light ${pathOpen === '/addCustomer' ? 'headActive' : 'none'}`}>
                        <i className="fas fa-user-plus" style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>Add Customer</p>
                      </Link>
                    </li>
                    )}
                    <li className="nav-item">
                      <hr className="dropdown-divider" style={{ width: "95%" }} />
                    </li>
                  </ul>
                </div>
              </li>
            </li>
            
            {/* Service Section */}
             {!isStaff && (
            <li className="nav-item">
              <div className={`nav-link ${isServiceOpen ? 'bg-light text-dark' : 'text-white'}`} onClick={toggleServiceDetails} >
                <i className="nav-icon fas fa-tools" />
                <p>Service<span style={{ position: "absolute", left: "auto", right: "8px" }}>
                  <i className={`fas ${isServiceOpen ? 'fa-chevron-down' : 'fa-chevron-left'}`} />
                </span></p>
              </div>
              <li id="serviceSubmenu">
                <div className={`collapse-menu ${isServiceOpen ? 'open' : ''}`} >
                  <ul className="nav flex-column serviceSubmenu">
                    <li className="nav-item">
                      <Link to="/stbreplacement" className={`nav-link text-light ${pathOpen === '/stbreplacement' ? 'headActive' : 'none'}`}>
                        <i className="fas fa-cog" style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>STB replacement</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/generalservice" className={`nav-link text-light ${pathOpen === '/generalservice' ? ' bg-light text-dark' : 'none'}`}>
                        <i className="fa fa-store-alt" style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>General Service charges</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/tripsheet" className={`nav-link text-light ${pathOpen === '/tripsheet' ? 'headActive' : 'none'}`}>
                        <i className="fa fa-th-list" style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>Trip Sheet</p>
                      </Link>
                    </li>
                    <li className="nav-item"><hr className="dropdown-divider" style={{ width: "95%" }} /></li>
                  </ul>
                </div>
              </li>
            </li>)}
             {!isStaff && (
            <li className="nav-item">
              <div className={`nav-link ${isAccountDetailsOpen ? 'bg-light text-dark' : 'text-white'}`} onClick={toggleAccountDetails}>
                <i className="nav-icon fas fa-list" />
                <p>Account Details<span style={{ position: "absolute", left: "auto", right: "8px" }}>
                  <i className={`fas ${isAccountDetailsOpen ? 'fa-chevron-down' : 'fa-chevron-left'}`} />
                </span></p>
              </div>
              <li id="AccountDetailsSubmenu">
                <div className={`collapse-menu ${isAccountDetailsOpen ? 'open' : ''}`} >
                  <ul className="nav flex-column serviceSubmenu">
                    <li className="nav-item">
                      <Link to="/generalExpense" className={`nav-link text-light ${pathOpen === '/generalExpense' ? 'headActive' : 'none'}`}>
                        <i className="fas fa-wallet" style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>General Expense</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/tccltopup" className={`nav-link text-light ${pathOpen === '/tccltopup' ? 'headActive' : 'none'}`}>
                        <i className="fas fa-credit-card" style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>TCCL Topup</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/materialpurchase" className={`nav-link text-light ${pathOpen === '/materialpurchase' ? 'headActive' : 'none'}`}>
                        <i className="fa fa-tag" style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>Material Purchase</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className={`nav-link text-light ${pathOpen === '/employeeSalary' ? 'headActive' : 'none'}`} to="/employeeSalary">
                        <i className="fas fa-rupee-sign" style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>Employee Salary</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/electricBill" className={`nav-link text-light ${pathOpen === '/electricBill' ? 'headActive' : 'none'}`}>
                        <i className="fas fa-receipt  " style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>Electric Bill</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/officeRent" className={`nav-link text-light ${pathOpen === '/officeRent' ? 'headActive' : 'none'}`}>
                        <i className="fas fa-money-bill" style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>Office Rent</p>
                      </Link>
                    </li>
                    <li className="nav-item"><hr className="dropdown-divider" style={{ width: "95%" }} /></li>
                  </ul>
                </div>
              </li>
            </li>)}
             {!isStaff && (
            <li className="nav-item">
              <div className={`nav-link ${isStockDetailsOpen ? 'bg-light text-dark' : 'text-white'}`} onClick={toggleStockDetails}>
                <i className="nav-icon fas fa-chart-bar" />
                <p>Stock Details<span style={{ position: "absolute", left: "auto", right: "8px" }}>
                  <i className={`fas ${isStockDetailsOpen ? 'fa-chevron-down' : 'fa-chevron-left'}`} />
                </span></p>
              </div>
              <li id="StockDetailsSubmenu">
                <div className={`collapse-menu ${isStockDetailsOpen ? 'open' : ''}`} >
                  <ul className="nav flex-column serviceSubmenu">
                    <li className="nav-item">
                      <Link to="/unassignedStb" className={`nav-link text-light ${pathOpen === '/unassignedStb' ? 'headActive' : 'none'}`}>
                        <i className="fas fa-users-slash" style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>Unassigned STB</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/StPurchase" className={`nav-link text-light ${pathOpen === '/StPurchase' ? 'headActive' : 'none'}`}>
                        <i className="fas fa-shopping-cart" style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>STB Purchase</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/stbReturn" className={`nav-link text-light ${pathOpen === '/stbReturn' ? 'headActive' : 'none'}`}>
                        <i className="fas fa-reply" style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>STB Return</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/stbType" className={`nav-link text-light ${pathOpen === '/stbType' ? 'headActive' : 'none'}`}>
                        <i className="fas fa-tasks" style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>STB types</p>
                      </Link>
                    </li>

                    <li className="nav-item"><hr className="dropdown-divider" style={{ width: "95%" }} /></li>
                  </ul>
                </div>
              </li>
            </li>)}
              {!isStaff && (
            <li className="nav-item">
              <div className={`nav-link ${isReportDetailsOpen ? 'bg-light text-dark' : 'text-white'}`} onClick={toggleReportDetails}>
                <i className="nav-icon fas fa-clipboard-list" />
                <p>Report Details<span style={{ position: "absolute", left: "auto", right: "8px" }}>
                  <i className={`fas ${isReportDetailsOpen ? 'fa-chevron-down' : 'fa-chevron-left'}`} />
                </span></p>
              </div>
              <li id="ReportDetailsSubmenu">
                <div className={`collapse-menu ${isReportDetailsOpen ? 'open' : ''}`} >
                  <ul className="nav flex-column serviceSubmenu">
                    {/* <li className="nav-item">
                      <Link to="/singlecustomerreport" className={`nav-link text-light ${pathOpen === '/singlecustomerreport' ? 'headActive' : 'none'}`}>
                        <i className="fas fa-users-slash" style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>Single Customer Report</p>
                      </Link>
                    </li> */}
                    <li className="nav-item">
                      <Link to="/connectionreport" className={`nav-link text-light ${pathOpen === '/connectionReport' ? 'headActive' : 'none'}`}>
                        <i className="fas fa-shopping-cart" style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>Connection Report</p>
                      </Link>
                    </li>
                    {/* <li className="nav-item">
                      <Link to="/customerreport" className={`nav-link text-light ${pathOpen === '/customerreport' ? 'headActive' : 'none'}`}>
                        <i className="fas fa-reply" style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>Customer Report</p>
                      </Link>
                    </li> */}
                    <li className="nav-item">
                      <Link to="/networkwisereport" className={`nav-link text-light ${pathOpen === '/networkWiseReport' ? 'headActive' : 'none'}`}>
                        <i className="fas fa-broadcast-tower" style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>Network Wise Report</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/reversecustomerreport" className={`nav-link text-light ${pathOpen === '/reverseCustomerReport' ? 'headActive' : 'none'}`}>
                        <i className="fas fa-undo" style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>Reverse Customer Report</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/collectionstaffreport" className={`nav-link text-light ${pathOpen === '/collectionStaffReport' ? 'headActive' : 'none'}`}>
                        <i className="fas fa-layer-group" style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>Collection Staff's Report</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/accountsreport" className={`nav-link text-light ${pathOpen === '/accountsReport' ? 'headActive' : 'none'}`}>
                        <i className="fas fa-user-circle" style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>Account Report</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/monthlyreport" className={`nav-link text-light ${pathOpen === '/monthlyReport' ? 'headActive' : 'none'}`}>
                        <i className="far fa-calendar" style={{ paddingLeft: "0.7rem", paddingRight: "5px" }} />
                        <p>Monthly Report</p>
                      </Link>
                    </li>
                    <li className="nav-item"><hr className="dropdown-divider" style={{ width: "95%" }} /></li>
                  </ul>
                </div>
              </li>
            </li>)}
             {!isStaff && (
            <li className="nav-item">
              <Link className="nav-link text-white" to="/staffDetails">
                <i className="nav-icon fas fa-book" />
                <p className="ms-2">Staff Details</p>
              </Link>
            </li>)}
             {!isStaff && (
            <li className="nav-item">
              <Link className="nav-link text-white" to="/planDetails">
                <i className="nav-icon fas fa-cogs" />
                <p className="ms-2">Plan Details</p>
              </Link>
            </li>)}
             {!isStaff && (
            <li className="nav-item">
            <Link className="nav-link text-white" to="/qrCodePage">
                <i className="nav-icon fas fa-qrcode" />
                <p className="ms-2">QR Code</p>
              </Link>
            </li>
            )}
             {!isStaff && (
            <li className="nav-item">
              <Link className="nav-link text-white" to="/home">
                <i className="nav-icon fas fa-cube" />
                <p className="ms-2">Package</p>
              </Link>
            </li>
            )}
             {!isStaff && (
            <li className="nav-item">
              <Link className="nav-link text-white" to="/TcclUpload">
                <i className="nav-icon fas fa-upload" />
                <p className="ms-2">TCCL Upload</p>
              </Link>
            </li>
            )}
             {!isStaff && (
            <li className="nav-item">
              <Link className="nav-link text-white" to="/SMSNotification">
                <i className="nav-icon fas fa-paper-plane" />
                <p className="ms-2">SMS Notification</p>
              </Link>
            </li>
)}
          </ul>
        </nav>
      </div>
    </aside>
  );
}

export default Sidebar;
